import * as React from "react";
import { SurveyPanel } from "survey-react-ui";
import type { PanelModel } from "survey-core";
import { Button } from "../components/Button";
import { createStyles } from "antd-style";

const useStyles = createStyles(({ css, token }) => ({
  panelWrapper: css`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  `,
  panelElementWrapper: css`
    flex: 1 1 400px;
    min-width: 0;

    .sd-row {
      padding-bottom: 0 !important;
    }
  `,
  panelActionWrapper: css`
    flex: 1 1 90px;
    margin-top: ${token.panelActionMarginTop};
  `,
}));

type SearchRowWrapperProps = {
  rowEl: React.JSX.Element;
  onSearch: () => void;
};

const SearchRowWrapper = ({ rowEl, onSearch }: SearchRowWrapperProps) => {
  const { styles } = useStyles();

  return (
    <div key="rd-row-0-with-action" className={styles.panelWrapper}>
      <div className={styles.panelElementWrapper}>{rowEl}</div>

      <div className={styles.panelActionWrapper}>
        <Button
          type="primary"
          onClick={onSearch}
          block
          styles={{ root: { minHeight: 48 } }}
        >
          Zoeken
        </Button>
      </div>
    </div>
  );
};

export class Panel extends SurveyPanel {
  get panel(): PanelModel {
    return super.panel;
  }

  protected renderContent(
    style: any,
    rows: React.JSX.Element[],
    className: string,
  ) {
    const panel: any = this.panel;
    const shouldShow = panel.hasSearchButton as boolean;

    if (!shouldShow || rows.length === 0) {
      return super.renderContent(style, rows, className);
    }

    const targetName = panel.searchTargetQuestionName as string;
    const target: any = panel.survey?.getQuestionByName?.(targetName);

    const onSearch = () => {
      // Validate the panel's own inputs (e.g. postal code regex, required fields)
      // before triggering the search instead of firing it regardless.
      if (!panel.validate(true, true)) {
        return;
      }

      target?.search();
    };

    const patchedRows = rows.map((rowEl, idx) => {
      if (idx !== 0) return rowEl;

      return (
        <SearchRowWrapper
          key="rd-row-0-with-action"
          rowEl={rowEl}
          onSearch={onSearch}
        />
      );
    });

    return super.renderContent(style, patchedRows, className);
  }
}
